/**
 * Aimtec DI
 * For more information visit the documentation <a href=\"%documentationUrl%\" target=\"_blank\">here</a>.
 *
 * The version of the OpenAPI document: {Version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EntityType {
    Bom = 'Bom',
    Calendar = 'Calendar',
    Customer = 'Customer',
    Inventory = 'Inventory',
    Item = 'Item',
    Manufacturing = 'Manufacturing',
    Operation = 'Operation',
    Output = 'Output',
    Purchase = 'Purchase',
    Resource = 'Resource',
    Routing = 'Routing',
    Sales = 'Sales',
    Shift = 'Shift',
    Subresource = 'Subresource',
    OrderExport = 'OrderExport',
    OperationExport = 'OperationExport',
    ResourceExport = 'ResourceExport',
    PurchaseExport = 'PurchaseExport',
    MiscellaneousOne = 'MiscellaneousOne',
    MiscellaneousTwo = 'MiscellaneousTwo',
    BomExport = 'BomExport',
    CalendarExport = 'CalendarExport',
    CustomerExport = 'CustomerExport',
    InventoryExport = 'InventoryExport',
    ItemExport = 'ItemExport',
    ManufacturingExport = 'ManufacturingExport',
    OutputExport = 'OutputExport',
    RoutingExport = 'RoutingExport',
    SalesExport = 'SalesExport',
    ShiftExport = 'ShiftExport',
    SubresourceExport = 'SubresourceExport',
    MiscellaneousOneExport = 'MiscellaneousOneExport',
    MiscellaneousTwoExport = 'MiscellaneousTwoExport'
}

